export default "__VITE_ASSET__CFWrJVwX__"